'use client'

import { Button } from '@repo/design-system-cf/components/button'
import { tw } from 'utils/classnames'
import { IconBookmark, IconBookmarkAdd } from '@repo/design-system-cf/components/icons'
export function BookmarkButton({
  isSaved,
  size = 'small',
  onClick,
}: {
  isSaved: boolean
  size?: 'small' | 'regular'
  onClick?: () => void
}) {
  return (
    <Button
      variant="ghost"
      size={'small'}
      onClick={() => onClick && onClick()}
      className={tw(
        'text-cf-violet border font-medium border-[#1313151F] flex gap-1 w-auto bg-cf-grey-50 flex-row items-center p-0 !px-2.5 rounded-[40px] hover:bg-cf-grey-200 hover:text-cf-violet',

        size === 'regular' ? 'h-[32px] !px-3 text-16' : 'h-[26px] !px-2.5 text-14',
      )}
      iconLeft={
        isSaved ? (
          <IconBookmark className={tw(size === 'regular' ? '!size-5' : '!size-4')} />
        ) : (
          <IconBookmarkAdd className={tw(size === 'regular' ? '!size-5' : '!size-4')} />
        )
      }
      data-testid="bookmark-button"
    >
      {isSaved ? 'Saved' : 'Save'}
    </Button>
  )
}
